module.exports = __webpack_public_path__ + "static/media/plymouth-go-drive.ab1e6d0f.png";